<template>
    <div>
        <div class="titleLine borderBot borderBotLeft0" :class="{'tiered': pricesList.length}" v-if="$isPriceShow()">
            <div v-if='!pricesList.length'>
                <div class="price">
                    <div class="money" v-show="salesPrice.length > 1"><sub>¥</sub>{{ salesPrice[0] }} - {{ salesPrice[salesPrice.length - 1] }}</div>
                    <div class="money" v-show="salesPrice.length == 1"><sub>¥</sub>{{ salesPrice[0] }}</div>
                    <div class="retail" v-show="retailPrice.length > 1">¥{{ retailPrice[0] }} ~ {{ retailPrice[retailPrice.length - 1] }}</div>
                    <div class="retail" v-show="retailPrice.length == 1">¥{{ retailPrice[0] }}</div>
                </div>
            </div>
            <div class="tieredUl" v-else>
                <div class="tieredLi" v-for="(item, index) in pricesList" :key="index">
                    <div class="price"><span>&#165;</span>{{ item.price }}</div>
                    <div class="piece" v-show="(index + 1) !== pricesList.length">{{ item.rangeStart }}～{{ item.rangeEnd }}件</div>
                    <div class="piece" v-show="(index + 1) == pricesList.length">≥{{ item.rangeStart }}件</div>
                </div>
            </div>
            <div class="name">{{ spuName }}</div>
        </div>
        <div class="titleLine borderBot borderBotLeft0" v-else>
            <div class="price">
                <div class="money">会员价</div>
                <div class="retail" v-show="retailPrice.length > 1">¥{{ retailPrice[0] }} ~ {{ retailPrice[retailPrice.length - 1] }}</div>
                <div class="retail" v-show="retailPrice.length == 1">¥{{ retailPrice[0] }}</div>
            </div>
            <div class="name">{{ spuName }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pricesList: {
            type: Array,
            default: () => {
                return []
            }
        },
        salesPrice: {
            type: Array,
            default: () => {
                return []
            }
        },
        retailPrice: {
            type: Array,
            default: () => {
                return []
            }
        },
        spuName: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .titleLine {
        font-size: 48px;
        color: #ff7a45;
        background: #ffffff;
        padding: 30px 32px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        &.tiered {
            padding: 0;
            .tieredUl{
                padding: 26px 0;
                height: 120px;
                box-sizing: border-box;
                background:linear-gradient(90deg,rgba(255,122,69,1) 0%,rgba(255,51,53,1) 100%);
                display: flex;
                justify-content: space-around;
                .tieredLi{
                    flex: 1;
                    font-size: 28px;
                    color: #ffffff;
                    text-align: center;
                    span{
                        font-size: 20px;
                    }
                    .piece{
                        font-size: 20px;
                    }
                }
            }
            .name{
                padding: 28px 96px 28px 32px;
                margin-top: 0;
            }
        }
        .price {
            .money {
                display: inline-block;
                height: 66px;
                line-height: 66px;
                sub {
                    font-size: 32px;
                    padding-right: 8px;
                }
            }
            .retail {
                display: inline-block;
                margin-left: 16px;
                font-size: 26px;
                color: #999999;
                text-decoration: line-through;
            }
        }
        .name {
            font-size: 32px;
            color: #000000;
            line-height: 44px;
            margin-top: 18px;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
</style>